export const ADD_VALIDATION = 'ADD_VALIDATION';
export const SET_VALID = 'SET_VALID';
export const SET_INVALID = 'SET_INVALID';
export const COURSE_SLUG_EXISTS = 'COURSE_SLUG_EXISTS';
export const COURSE_SLUG_OKAY = 'COURSE_SLUG_OKAY';
export const ACTIVATE_VALIDATIONS = 'ACTIVATE_VALIDATIONS';
export const RESET_VALIDATIONS = 'RESET_VALIDATIONS';
